// extracted by mini-css-extract-plugin
export default {"videoUploadPage":"UploadVideoPage_videoUploadPage__PJ-R8","videoUploadHeader":"UploadVideoPage_videoUploadHeader__6bss6","searchInput":"UploadVideoPage_searchInput__HoOlN"};